import {formatDate} from 'mc/lib/utils/commons';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import * as FormaUhradyInfo from '../../api/FormaUhradyInfo';
import * as TypNevyporadaniPlatby from '../../api/TypNevyporadaniPlatby';
import {formatBoolean, formatCurrencyWithoutSymbol} from '../../utils/popUtils';
import DataTable from '../datatable/DataTable';
import PlatbaActionsMenu from './PlatbaActionsMenu';

const {ColumnType, ColumnAlignment} = DataTable;

export default class PlatbaTable extends PureComponent {

    static propTypes = {
        rows: PropTypes.array.isRequired,
        visibleColumnNames: PropTypes.arrayOf(PropTypes.string),
        readOnly: PropTypes.bool,
        headerOnly: PropTypes.bool,
        bodyOnly: PropTypes.bool,
    };

    static defaultProps = {
        readOnly: false,
    };

    constructor(props) {
        super(props);

        this.columns = [
            {
                name: "cisloDokladu",
                label: "Číslo dokladu",
            },
            {
                name: "vs",
                label: "VS",
            },
            {
                name: "castkaPlatby",
                label: "Částka platby",
                format: formatCurrencyWithoutSymbol,
                alignment: ColumnAlignment.RIGHT,
            },
            {
                name: "castkaVyrovnani",
                label: "Částka vyrovnání",
                format: formatCurrencyWithoutSymbol,
                alignment: ColumnAlignment.RIGHT,
            },
            {
                name: "vratka",
                label: "K vrácení / Vráceno",
                alignment: ColumnAlignment.RIGHT,
                component: this.renderVratka,
            },
            {
                name: "datumPlatby",
                label: "Datum platby",
                format: formatDate,
            },
            {
                name: "formaUhrady",
                label: "Forma úhrady",
                format: FormaUhradyInfo.getCaption,
            },
            {
                name: "vyrazeno",
                label: "Vyřazená",
                format: formatBoolean,
            },
            {
                name: "typNevyporadani",
                label: "Nález",
                format: TypNevyporadaniPlatby.getCaption,
            },
            {
                name: "poznamka",
                label: "Poznámka",
            },
            {
                name: "actions",
                type: ColumnType.ACTIONS,
                component: this.renderActions,
            },
        ];
    }

    renderVratka = ({row}) => {
        return <div>{formatCurrencyWithoutSymbol(row.vratkaNerealizovana)} / {formatCurrencyWithoutSymbol(row.vratkaRealizovana)}</div>;
    };

    renderActions = ({row}) => {
        const {readOnly} = this.props;
        return <PlatbaActionsMenu platba={row} readOnly={readOnly}/>;
    };

    render() {
        const {rows, visibleColumnNames, headerOnly, bodyOnly} = this.props;
        return <DataTable columns={this.columns}
                          visibleColumnNames={visibleColumnNames}
                          rows={rows}
                          headerOnly={headerOnly}
                          bodyOnly={bodyOnly}
                          bodyProps={{className: "items-list"}}
                          bodyRowProps={{className: "card-block actions-hover"}}
                          striped
                          hover
                          bordered/>;
    }

}
